<template>
    <div>
        <div class="date-container">
            <div class="date-content">
                <div>
                    <span class="date-title">{{
                        $t('strategy.onepage.date.start')
                    }}</span>
                    <div class="position-relative">
                        <b-form-input
                            @update="stateStart = true"
                            @blur="
                                updateDate(
                                    { period_start: dateStart },
                                    { stateStart }
                                )
                            "
                            class="date-input"
                            v-model="dateStart"
                            type="number"
                            placeholder="Ano Inicial"
                            :state="stateStart"
                            :disabled="disabled"
                        />
                        <ValidationInput :status="stateStart" size="1rem" />
                    </div>
                </div>
                <div>
                    <span class="date-title">{{
                        $t('strategy.onepage.date.end')
                    }}</span>
                    <div class="position-relative">
                        <b-form-input
                            @update="stateEnd = true"
                            @blur="
                                updateDate(
                                    { period_end: dateEnd },
                                    { stateEnd }
                                )
                            "
                            class="date-input"
                            v-model="dateEnd"
                            type="number"
                            placeholder="Ano Final"
                            :state="stateEnd"
                            :disabled="disabled"
                        />
                        <ValidationInput :status="stateEnd" size="1rem" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import ValidationInput from './ValidationInput.vue'
export default {
    name: 'DatePickerStrategy',
    components: {
        ValidationInput,
    },
    props: {
        onepage: {
            type: Object,
        },
        disabled: {
            type: Boolean,
        },
    },
    data() {
        return {
            dateStart: this.onepage.period_start,
            dateEnd: this.onepage.period_end,
            stateStart: null,
            stateEnd: null,
        }
    },
    created() {
        this.dateStart = parseInt(this.onepage.period_start)
        this.dateEnd = parseInt(this.onepage.period_end)
    },
    methods: {
        ...mapActions('strategy', ['updateOnepage', 'updateOnepageDate']),
        updateDate(body, state) {
            this.updateOnepageDate(body).then((data) => {
                const params = {
                    id: this.onepage.id,
                    body: {
                        ...data,
                    },
                }
                this.updateOnepage(params).finally(() => {
                    setTimeout(() => {
                        this[Object.keys(state)] = null
                    }, 1000)
                })
            })
        },
    },
}
</script>

<style lang="sass" scoped>
.date-container
    display: flex
    flex-direction: column
    align-items: start
    column-gap: .5rem
    .date-title
        font-size: 1rem
        color: #FFF
    .date-content
        display: flex
        column-gap: 1rem
        .date-input
            cursor: pointer
            border: 1px #BEC0C0 solid
            background: #FFF
            color: #022B4F
            border-radius: 5px
            padding: 0.5rem
            width: 7rem
            text-align: center
</style>
